import React, { Fragment } from 'react';
import { DataContext } from './DataContext.js'
import Icon from '~/core/scripts/components/Icon';

const Basesideview = React.memo(function(props) {

  const [ state, updateState ] = React.useContext(DataContext);

  const data = state.crimeData.records.find(function(r){
    return r.district === "Nordrhein-Westfalen";
  }).data[state.crime]; // FIXME: use mapping instead of find

  const dot = state.colorSteps.reduce(function(p,c){
    return (data.percapita >= c[0]) ? c[1] : p;
  },"#ffffff");
  
  const m = [null,"Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  const from = data.monthly[0];
  const till = [...data.monthly].pop();
  
  return (
    <div className="iframeteaser__details details">
      <div className="details__header">
        <div className="details__title">Kriminalitätsatlas NRW</div>
      </div>
      <div className="details__subheader">
        <div className="details__icon"><Icon type={state.crimeData.delicts[state.crime].id} /></div>
        <div className="details__subtitle">{state.crimeData.delicts[state.crime].label}</div>
      </div>
      <div className="details__body">
        <div className="details__item cases-abs">
          <div className="details__item-value">{data.cases}</div>
          <div className="details__item-label">Fälle von {m[data.monthly[0][1]]}
          {(from[0]!==till[0]) && (
            <Fragment>&nbsp;{data.monthly[0][0]}</Fragment>
          )} bis {m[[...data.monthly].pop()[1]]} {[...data.monthly].pop()[0]}</div>
        </div>
        <div className="details__item diff">
          <div className="details__item-value">{(data.difference>0&&'+')}{data.difference} %</div>
          <div className="details__item-label">im Vergleich zum Vorjahreszeitraum</div>
        </div>
        <div className="details__item cases-rel">
          <div className="details__item-value">
            <div className="dot" style={{ backgroundColor: dot }}></div>
            {data.percapita}
          </div>
          <div className="details__item-label">Fälle pro 100&#8239;000 Einwohner</div>
        </div>
      </div>
    </div>
  );
});

export default Basesideview;